<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="left-sidebar">
    <v-layout
      justify-center
      wrap>
      <v-flex
        md12>
        <!-- add font dialog -->
        <v-dialog
            v-model="addFontDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('mobile.addNewFontBtn')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="addForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  ref="name"
                  v-model="name"
                  :placeholder="$t('mobile.name')"
                  :error-messages="fontNameErrors"
                />
                <v-text-field
                  ref="price"
                  v-model="price"
                  :placeholder="$t('mobile.price')"
                  :error-messages="fontPriceErrors"
                />
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancel()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="sumbitFont()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>
      <!-- edit dialog -->
        <v-dialog
            v-model="editFontDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('mobile.editFont')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="editForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  ref="name"
                  v-model="editName"
                  :placeholder="$t('mobile.name')"
                  :error-messages="fontEditNameErrors"
                />
                <v-text-field
                  ref="price"
                  v-model="editPrice"
                  :placeholder="$t('mobile.price')"
                  :error-messages="fontEditPriceErrors"
                />
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancel()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="updateSelected()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>

      <!-- add slide dialog -->
        <v-dialog
            v-model="addSlideDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('mobile.addNewSlide')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="addSlideForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="slideName"
                  :placeholder="$t('mobile.slideName')"
                  :error-messages="slideNameErrors"
                />
                <v-text-field
                  v-model="slideActionUrl"
                  :placeholder="$t('mobile.bannerActionUrl')"
                />
                <v-checkbox
                  v-model="isActiveSlide"
                  :label="$t('mobile.isActive')"
              ></v-checkbox>
              <input id="slide-file" type='file' accept="image/*" @click="onFileUpload"/><br>
              <img id="Image">
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelSlide()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="sumbitSlide()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>

      <!-- edit slide dialog -->
      <v-dialog
            v-model="editSlideDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('mobile.editSlide')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="addSlideForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editSlideName"
                  :label="$t('mobile.slideName')"
                  :placeholder="$t('mobile.slideName')"
                  :error-messages="editSlideNameErrors"
                />
                <v-text-field
                  v-model="editSlideActionUrl"
                  :label="$t('mobile.bannerActionUrl')"
                  :placeholder="$t('mobile.bannerActionUrl')"
                />
                <v-checkbox
                  v-model="isActiveEditSlide"
                  :label="$t('mobile.isActive')"
              ></v-checkbox>
              <img id="edit-slide" class="uploaded-img" src=""><br><br>
              <input id="edit-slide-file" type='file' @change="setEditSlideImage()"/>
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelEditSlide()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="sumbitEditSlide()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>

      <!-- add banner dialog -->
        <v-dialog
            v-model="addBannerDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('mobile.addNewBanner')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="addBannerForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="bannerName"
                  :placeholder="$t('mobile.slideName')"
                  :error-messages="bannerNameErrors"
                />
                <v-text-field
                  v-model="bannerActionUrl"
                  :placeholder="$t('mobile.bannerActionUrl')"
                />
                <v-checkbox
                  v-model="isActiveBanner"
                  :label="$t('mobile.isActive')"
              ></v-checkbox>
              <input id="banner-file" type='file' accept="image/*"/><br>
              <img id="bannerImage">
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelBanner()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="submitBanner()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>
      <!-- edit banner dialog -->
        <v-dialog
            v-model="editBannerDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
        >
          <v-card-title class="text-h6">
             {{ $t('mobile.editBanner')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="editBannerForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editBannerName"
                  :placeholder="$t('mobile.bannerName')"
                  :error-messages="editBannerNameErrors"
                />
                <v-text-field
                  v-model="editBannerActionUrl"
                  :placeholder="$t('mobile.bannerActionUrl')"
                />
                <v-checkbox
                  v-model="isActiveBannerEdit"
                  :label="$t('mobile.isActive')"
              ></v-checkbox>
              <img id="uploaded-img-banner" class="uploaded-img" src=""><br><br>
              <input id="edit-banner-file" type='file' @change="setEditBannerImage()"/><br>
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelEditBanner()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="submitEditBanner()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>

      <!-- add product design dialog -->
        <v-dialog
            v-model="addProductDesignDialog"
            persistent
            max-width="400"
            content-class="dialog-color"
          >
          <v-card-title class="text-h6">
             {{ $t('mobile.addProductDesign')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="addProductDesignForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="designName"
                  :placeholder="$t('mobile.designName')"
                  :error-messages="designNameErrors"
                />
              <label for="design-image">{{ $t('mobile.iconSmall')}}</label><br>
              <input id="design-icon-small" type='file'/><br>
              <img id="designIconSmall"><br>
              <label for="design-image">{{ $t('mobile.image')}}</label><br>
              <input id="design-image" type='file'/><br>
              <img id="designImage"><br>
              <label for="design-image-preview">{{ $t('mobile.imagePreview')}}</label><br>
              <input id="design-image-preview" type='file'/><br>
              <img id="designImagePreview">
            </v-col>
            </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelProductDesign()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="submitProductDesign()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>

      <!-- edit product design dialog -->
        <v-dialog
            v-model="editProductDesignDialog"
            persistent
            max-width="600"
            content-class="dialog-color"
          >
          <v-card-title class="text-h6">
             {{ $t('mobile.editProductDesign')}}
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-form ref="editProductDesignForm">
            <v-row class="dialog-card-body">
            <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editDesignName"
                  :label="$t('mobile.designName')"
                  :placeholder="$t('mobile.designName')"
                  :error-messages="editDesignNameErrors"
                />
            </v-col>
          <v-col cols="12" sm="6" md="6">
             <label for="edit-design-image">{{ $t('mobile.image')}}</label><br>
             <img id="uploaded-design-image" class="uploaded-img" src=""><br><br>
             <input id="edit-design-image" type='file' @change="setEditDesignImage()"/><br>
          </v-col>
          <v-col cols="12" sm="6" md="" >
            <label for="edit-design-image-preview">{{ $t('mobile.imagePreview')}}</label><br>
            <img id="uploaded-design-image-preview" class="uploaded-img" src=""><br><br>
            <input id="edit-design-image-preview" type='file' @change="setEditDesignImagePreview()"/><br>
          </v-col>
          <v-col cols="12" sm="6" md="4" >
            <label for="edit-design-icon-small">{{ $t('mobile.iconSmall')}}</label><br>
            <img id="uploaded-design-icon-small" class="icon-img-small" src=""><br><br>
            <input id="edit-design-icon-small" type='file' @change="setEditDesignIconSmall()"/><br>
          </v-col>
        </v-row>
        </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="cancelEditProductDesign()"
              >
              {{ $t('cancel')}}
            </v-btn>
            <v-btn
              class="add-new mb-1 mt-8 mr-3"
              dark
              @click="submitEditProductDesign()">
              {{ $t('submit')}}
            </v-btn>
          </v-card-actions>
      </v-dialog>

        <v-card
        elevation="2"
        class="card-body card-body-height">
        <v-card>
            <v-card-title>{{ $t('mobile.title')}}</v-card-title>
        </v-card><br>
        <v-tabs
            fixed-tabs
            v-model="tab"
          >
          <v-tabs-slider color="amber darken-3"></v-tabs-slider>
          <v-tab
            v-for="(item, index) in items"
            :class="{active: currentTab === index}"
            @click="currentTab = index"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-card flat>
            <div v-show="currentTab === 0"><v-card-text>
            <v-btn
              dark
              class="add-new mb-1 mt-8 mr-3"
              @click="createFont()">{{ $t('mobile.addNew') }}</v-btn><br><br>
            <v-text-field
              v-model="searchFonts"
              :search="searchFonts"
              :label="$t('search')"
              :placeholder="$t('search')"
              single-line
              hide-details
              class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headersFonts"
              :items="getAllFonts"
              :rows-per-page-items ="rowsAmount"
              :search="searchFonts"
              class="elevation-1"
            >
              <template v-slot:item="props">
                <tr>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="openUpdateSelected(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteSelected(props)">mdi-delete</v-icon>
                  </td>
                  <td>
                    <div>{{ props.item.name }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            </v-card-text></div>
            <div v-show="currentTab === 1"><v-card-text>
             <div>
              <v-btn
                dark
                class="add-new mb-1 mt-8 mr-3"
                @click="openAddSlide()"
                >{{ $t('mobile.addNew') }}</v-btn><br>
              <v-text-field
                v-model="searchSlide"
                :search="searchSlide"
                :label="$t('search')"
                :placeholder="$t('search')"
                single-line
                hide-details
                class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headersSlide"
              :items="getAllSlides"
              :rows-per-page-items ="rowsAmount"
              :search="searchSlide"
              class="elevation-1"
            >
              <template v-slot:item="props">
                <tr>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="editSlide(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteSlide(props)">mdi-delete</v-icon>
                  </td>
                  <td>
                    <div v-if="props.item.image">
                        <!-- <v-img class="table-image" v-bind:src=props.item.image></v-img> -->
                        <img class="table-image" v-bind:src=props.item.image>
                    </div>
                    <div v-else>---</div>
                  </td>
                  <td>
                    <div v-if="props.item.active == 1">{{ $t('active') }}</div>
                    <div v-else>{{ $t('inactive') }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
               </div><br><br>
            </v-card-text></div>
            <div v-show="currentTab === 2"><v-card-text>
              <!-- <div ml-4 class="tab-headline">{{ $t('mobile.bannerImages') }}</div> -->
                <v-btn
                  dark
                  class="add-new  mb-1 mt-8 mr-3"
                  @click="openAddBanner()">{{ $t('mobile.addNew') }}</v-btn><br>
            <v-text-field
              v-model="searchBanner"
              :search="searchBanner"
              :label="$t('search')"
              :placeholder="$t('search')"
              single-line
              hide-details
              class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headersBanners"
              :items="getAllBanners"
              :rows-per-page-items ="rowsAmount"
              :search="searchBanner"
              class="elevation-1"
            >
              <template v-slot:item="props">
                <tr>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="editBanner(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteBanner(props)">mdi-delete</v-icon>
                  </td>
                  <td>
                    <div v-if="props.item.image">
                        <!-- <v-img class="table-image" v-bind:src=props.item.image></v-img> -->
                        <img class="table-image" v-bind:src=props.item.image>
                    </div>
                    <div v-else>---</div>
                  </td>
                  <td>
                    <div v-if="props.item.active == 1">{{ $t('active') }}</div>
                    <div v-else>{{ $t('inactive') }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            </v-card-text></div>
            <div v-show="currentTab === 3"><v-card-text>
            <v-btn
              dark
              class="add-new  mb-1 mt-8 mr-3"
              @click="openAddDesign()">{{ $t('mobile.addNew') }}</v-btn><br>
            <v-text-field
              v-model="searchDesigns"
              :search="searchDesigns"
              :label="$t('search')"
              :placeholder="$t('search')"
              single-line
              hide-details
              class="search-field">
            </v-text-field>
            <v-data-table
              :headers="headersDesign"
              :items="getAllProductDesigns"
              :rows-per-page-items ="rowsAmount"
              :search="searchDesigns"
              class="elevation-1"
            >
              <template v-slot:item="props">
                <tr>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="editDesign(props)">mdi-pencil</v-icon>
                  </td>
                  <td class="justify-center icon-table-wrap">
                      <v-icon
                          medium
                          class="icon-table"
                          @click="deleteDesign(props)">mdi-delete</v-icon>
                  </td>
                  <td>
                  <div v-if="props.item.small_icon">
                        <img class="table-image-icon" v-bind:src=props.item.small_icon>
                    </div>
                    <div v-else>---</div>
                  </td>
                  <td>
                    <div v-if="props.item.image">
                        <!-- <v-img class="table-image" v-bind:src=props.item.image></v-img> -->
                        <img class="table-image" v-bind:src=props.item.image>
                    </div>
                    <div v-else>---</div>
                  </td>
                  <td>
                    <div>{{ props.item.title }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            </v-card-text></div>
          </v-card>
        </v-tabs-items>
      </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {  mapGetters } from 'vuex';
import i18n from '../../i18n'
import { required, numeric } from 'vuelidate/lib/validators'
import axios from 'axios'
import Vue from 'vue'

export default {
    data () {
      return {
          currentTab: 0,
          tab: null,
          checked: false,
          addFontDialog: false,
          editFontDialog: false,
          addSlideDialog: false,
          addBannerDialog: false,
          name: '',
          price: '',
          editName: '',
          editPrice: '',
          searchSlide: '',
          searchFonts: '',
          searchBanner: '',
          searchDesigns: '',
          slideName:'',
          slideTag: '',
          isActiveSlide: false,
          bannerName: '',
          bannerActionUrl: '',
          slideActionUrl: '',
          isActiveBanner: false,
          slideImage: '',
          editBannerDialog: false,
          editBannerName: '',
          editBannerActionUrl: '',
          isActiveBannerEdit: false,
          editSlideDialog: false,
          editSlideName: '',
          editSlideActionUrl: '',
          isActiveEditSlide: false,
          addProductDesignDialog: '',
          designName: '',
          editProductDesignDialog: false,
          editDesignName: '',
          FILE: null,
          url: null,
          items: [ i18n.t('mobile.uploadFonts'), i18n.t('mobile.slide'), i18n.t('mobile.banner'),
          i18n.t('mobile.productDesigns')],
          rowsAmount: [10,20,25,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
          headersFonts: [
              { text: i18n.t(''),},
              { text: i18n.t(''),},
              { text: i18n.t('mobile.fontName'), value: 'name'},
          ],
          headersSlide: [
                { text: i18n.t(''),},
                { text: i18n.t(''),},
                { text: i18n.t('mobile.image'), value: 'image'},
                { text: i18n.t('mobile.isActive'), value: 'active'},
            ],
            headersBanners: [
                { text: i18n.t(''),},
                { text: i18n.t(''),},
                { text: i18n.t('mobile.image'), value: 'image'},
                { text: i18n.t('mobile.isActive'), value: 'active'},
            ],
            headersDesign: [
                { text: i18n.t(''),},
                { text: i18n.t(''),},
                { text: i18n.t('mobile.smallIcon'), value: 'small_icon'},
                { text: i18n.t('mobile.image'), value: 'image'},
                { text: i18n.t('mobile.titleDesign'), value: 'title'}
            ],
        }
    },
    validations: {
        name: { required },
        price:{ required, numeric },
        editName: { required },
        editPrice:{ required, numeric },
        slideName: { required },
        bannerName: { required },
        editBannerName: { required },
        editSlideName: { required },
        designName: { required },
        editDesignName: { required }
    },
    computed: {
      ...mapGetters([
          'getAllFonts',
          'getFont',
          'getAllBanners',
          'getAllSlides',
          'getAllProductDesigns',
      ]),
      fontNameErrors() {
            const errors = [];
                if (!this.$v.name.$dirty) return errors;
                    !this.$v.name.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
      },
      fontPriceErrors() {
          const errors = [];
              if (!this.$v.price.$dirty) return errors;
                  !this.$v.price.numeric && errors.push(i18n.tc('fieldValueNumber'));
                  !this.$v.price.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      fontEditNameErrors() {
            const errors = [];
                if (!this.$v.editName.$dirty) return errors;
                    !this.$v.editName.required && errors.push(i18n.tc('fieldRequired'));
                return errors;
      },
      fontEditPriceErrors() {
          const errors = [];
              if (!this.$v.editPrice.$dirty) return errors;
                  !this.$v.editPrice.numeric && errors.push(i18n.tc('fieldValueNumber'));
                  !this.$v.editPrice.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      slideNameErrors(){
         const errors = [];
              if (!this.$v.slideName.$dirty) return errors;
                  !this.$v.slideName.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      bannerNameErrors(){
         const errors = [];
              if (!this.$v.bannerName.$dirty) return errors;
                  !this.$v.bannerName.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      editBannerNameErrors(){
         const errors = [];
              if (!this.$v.editBannerName.$dirty) return errors;
                  !this.$v.editBannerName.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      editSlideNameErrors(){
         const errors = [];
              if (!this.$v.editSlideName.$dirty) return errors;
                  !this.$v.editSlideName.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      designNameErrors(){
          const errors = [];
              if (!this.$v.designName.$dirty) return errors;
                  !this.$v.designName.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      },
      editDesignNameErrors(){
          const errors = [];
              if (!this.$v.editDesignName.$dirty) return errors;
                  !this.$v.editDesignName.required && errors.push(i18n.tc('fieldRequired'));
              return errors;
      }
    },
    methods:{
      //fonts
      createFont(){
        this.addFontDialog = true;
      },
      sumbitFont(){
        const data = {
          name: this.name,
          price: this.price
        }
            if(this.$v.name.$invalid || this.$v.price.$invalid){
                this.$v.$touch();
                return;
            } else{
                this.$store.dispatch('CREATE_FONT', data)
                    .then(() => this.$store.dispatch('LOAD_ALL_FONTS'));
                    this.resetForm()
                    this.addFontDialog = false
            }
      },
      cancel(){
        if(this.addFontDialog){
          this.addFontDialog = false;
          this.resetForm()
        } else {
          this.editFontDialog = false;
        }

      },
      openUpdateSelected(props){
        localStorage.setItem('fontId', props.item.id)
          this.editFontDialog = true;
             this.$store.dispatch('GET_FONT', props.item.id)
            .then(res => {
                let response = res.data.data;
                this.editName = response.name;
                this.editPrice = response.price;
            })
      },
      updateSelected(){
        const data = {
          id: localStorage.getItem('fontId'),
          name: this.editName,
          price: this.editPrice
        }
        this.$store.dispatch('UPDATE_FONT', data)
            .then(() => this.$store.dispatch('LOAD_ALL_FONTS'));
            this.editFontDialog = false;
      },
      deleteSelected(props){
          if (confirm(i18n.t(`areYouSureToDelete_`) + `${props.item.name}?`)) {
            this.$store.dispatch('DELETE_FONT', props.item.id)
                .then(() => this.$store.dispatch('LOAD_ALL_FONTS'));
            }
      },
      resetForm(){
          this.$refs.addForm.reset();
          this.$v.$reset();
      },
      //slide
      onFileUpload(event){
          this.FILE = event.target.files[0];
          // this.imgText = this.FILE.name;
          const file = event.target.files[0];
          this.url = URL.createObjectURL(file);
      },
      openAddSlide(){
        this.addSlideDialog = true;
      },
      resetSlideForm(){
          this.$refs.addSlideForm.reset();
          this.$v.$reset();
          document.getElementById('slide-file').value = '';
      },
      cancelSlide(){
        this.resetSlideForm();
        this.addSlideDialog = false;
      },
      sumbitSlide(){
        const slideFile = document.getElementById('slide-file').files[0];

        let formData = new FormData();
            formData.append('type', "mobile-header");
            formData.append('active', this.isActiveSlide == null ? false : this.isActiveSlide);
            formData.append('action_url', this.slideActionUrl);
            formData.append('translations[0][name]', this.slideName);
            formData.append('translations[0][image]', slideFile);
            formData.append('translations[0][language_identifier]', 'sr');

            if(this.$v.slideName.$invalid){
                this.$v.$touch();
                slideFile.style.color = 'red';
                return;
            } else {
                this.$store.dispatch('CREATE_SLIDE', formData)
                    .then(() => this.$store.dispatch('LOAD_ALL_SLIDES'));
                this.addSlideDialog = false;
                this.resetSlideForm();
            }
      },
      editSlide(props){
          this.editSlideDialog = true;
          localStorage.setItem('slideId', props.item.id)
          this.$store.dispatch('GET_SLIDE', props.item.id)
            .then(res => {
                let response = res.data.data;
                this.editSlideName = response.name;
                this.editSlideActionUrl = response.action_url
                this.isActiveEditSlide = response.active == 0 ? false : true;
                document.getElementById('edit-slide').src = response.image;
            })
      },
      cancelEditSlide(){
          this.editSlideDialog = false;
          this.$v.$reset();
          document.getElementById('edit-slide-file').style.color = 'black';
          document.getElementById('edit-slide-file').value = '';
      },
      sumbitEditSlide(){
          let editSlideFile = document.getElementById('edit-slide-file').files[0],
              uploadedSlideImg = document.getElementById('edit-slide').src,
              id = localStorage.getItem('slideId');

          let formData = new FormData();
              formData.append('type', "mobile-header");
              formData.append('active', this.isActiveEditSlide == null ? false : this.isActiveEditSlide);
              formData.append('action_url', this.editSlideActionUrl);
              formData.append('translations[0][name]', this.editSlideName);
              formData.append('translations[0][image]', editSlideFile == undefined ? uploadedSlideImg : editSlideFile);
              formData.append('translations[0][language_identifier]', 'sr');

          if(this.$v.editSlideName.$invalid){
              this.$v.$touch();
              return;
          } else {
            return new Promise((resolve) => {
              axios.put(`slide/${id}`, formData)
                .then(resp => {
                  if(!resp.data.error){
                        Vue.toasted.show(i18n.tc(`successfully`),{
                            theme: 'outline',
                            singleton: true,
                            position:'top-center',
                            action :
                              {
                                  text : i18n.tc(`ok`),
                                  onClick : (e, toastObject) => {
                                      toastObject.goAway(0);
                                  }
                              }
                        });
                        this.$store.dispatch('LOAD_ALL_SLIDES')
                        this.cancelEditSlide();
                  } else {
                    console.log(resp.data.error)
                  }
              resolve(resp)
              })
            })
          }
      },
      deleteSlide(props){
          if (confirm(i18n.t(`areYouSureToDelete`))) {
            this.$store.dispatch('DELETE_SLIDE', props.item.id)
                .then(() => this.$store.dispatch('LOAD_ALL_SLIDES'));
          }
      },
      //banners
      openAddBanner(){
        this.addBannerDialog = true;
      },
      cancelBanner(){
        this.resetBannerForm();
        this.addBannerDialog = false;
        document.getElementById('banner-file').value = '';
      },
      resetBannerForm(){
          this.$refs.addBannerForm.reset();
          this.$v.$reset();
          document.getElementById('banner-file').value = '';
      },
      resetEditBannerForm(){
          this.$refs.editBannerForm.reset();
          this.$v.$reset();
      },
      cancelEditBanner(){
        this.resetEditBannerForm();
        this.editBannerDialog = false;
        document.getElementById('edit-banner-file').value = '';
      },
      submitBanner(){
        const bannerFile = document.getElementById('banner-file').files[0];

        let formData = new FormData();
            formData.append('active', this.isActiveBanner == null ? false : this.isActiveBanner);
            formData.append('name', this.bannerName);
            formData.append('image', bannerFile);
            formData.append('action_url', this.bannerActionUrl);

            if(this.$v.bannerName.$invalid || bannerFile.value == ''){
                this.$v.$touch();
                bannerFile.style.color = 'red';
                return;
            } else {
                this.$store.dispatch('CREATE_BANNER', formData)
                    .then(() => this.$store.dispatch('LOAD_ALL_BANNERS'));
                this.addBannerDialog = false;
                this.resetBannerForm();
            }
      },
      deleteBanner(props){
          if (confirm(i18n.t(`areYouSureToDelete`))) {
            this.$store.dispatch('DELETE_BANNER', props.item.id)
                .then(() => this.$store.dispatch('LOAD_ALL_BANNERS'));
          }
      },
      setEditBannerImage(){
          const bannerFile = document.getElementById('edit-banner-file').files[0];
           let output = document.getElementById('uploaded-img-banner');
                output.src = URL.createObjectURL(bannerFile);

                output.onload = function() {
                    URL.revokeObjectURL(output.src)
                }
      },
      editBanner(props){
          this.editBannerDialog = true;
          localStorage.setItem('bannerId', props.item.id)
          this.$store.dispatch('GET_BANNER', props.item.id)
            .then(res => {
                let response = res.data.data;
                this.editBannerName = response.name;
                this.isActiveBannerEdit = response.active
                this.editBannerActionUrl = response.action_url;
                document.getElementById('uploaded-img-banner').src = response.image;
            })
      },
      submitEditBanner(){

        let editBannerFile = document.getElementById('edit-banner-file').files[0],
            uploadedImgBanner = document.getElementById('uploaded-img-banner').src,
            id = localStorage.getItem('bannerId');

        let formData = new FormData();
            formData.append('active', this.isActiveBannerEdit == null ? false : this.isActiveBannerEdit);
            formData.append('name', this.editBannerName);
            formData.append('image', editBannerFile == undefined ? uploadedImgBanner : editBannerFile);
            formData.append('action_url', this.editBannerActionUrl);

          if(this.$v.editBannerName.$invalid){
              this.$v.$touch();
              editBannerFile.style.color = 'red';
              return;
          } else {
            return new Promise((resolve) => {
              axios.put(`banner/${id}`, formData)
                .then(resp => {
                  if(!resp.data.error){
                        Vue.toasted.show(i18n.tc(`successfully`),{
                            theme: 'outline',
                            singleton: true,
                            position:'top-center',
                            action :
                              {
                                  text : i18n.tc(`ok`),
                                  onClick : (e, toastObject) => {
                                      toastObject.goAway(0);
                                  }
                              }
                        });
                        this.$store.dispatch('LOAD_ALL_BANNERS')
                        this.cancelEditBanner();
                  } else {
                    console.log(resp.data.error)
                  }
              resolve(resp)
              })
          })
        }
      },

      //design
      openAddDesign(){
        this.$router.push(`/${i18n.locale}/design/add-new-design`)
        // this.addProductDesignDialog = true;
      },
      cancelProductDesign(){
        this.addProductDesignDialog = false;
        this.$refs.addProductDesignForm.reset();
        this.$v.$reset();
        document.getElementById('design-image').style.color = 'black';
        document.getElementById('design-image-preview').style.color = 'black';
        document.getElementById('design-icon-small').style.color = 'black';
        document.getElementById('design-image').value = '';
        document.getElementById('design-image-preview').value = '';
        document.getElementById('design-icon-small').value = '';
      },
      submitProductDesign(){
        let image = document.getElementById('design-image').files[0],
            imagePreview = document.getElementById('design-image-preview').files[0],
            iconSmall = document.getElementById('design-icon-small').files[0];

        let formData = new FormData();
            formData.append('title', this.designName);
            formData.append('small_icon', iconSmall);
            formData.append('image', image);
            formData.append('preview_image', imagePreview);

            if(this.$v.designName.$invalid || image.value == ''
              || imagePreview.value == '' || iconSmall.value == ''){
              this.$v.$touch();
                image.style.color = 'red';
                imagePreview.style.color = 'red';
                iconSmall.style.color = 'red';
              return;
          } else {
            this.$store.dispatch('CREATE_PRODUCT_DESIGN', formData)
                    .then(() => this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS'));
            this.cancelProductDesign();
          }
      },
      editDesign(props){
        this.$router.push(`/${i18n.locale}/design/edit-design/${props.item.id}`)
        //   this.editProductDesignDialog = true;
        //   localStorage.setItem('productDesignId', props.item.id)
        //
        //   this.$store.dispatch('GET_PRODUCT_DESIGN', props.item.id)
        //     .then(res => {
        //         let response = res.data.data;
        //         this.editDesignName = response.title;
        //         this.editDesignPrice = response.price
        //         document.getElementById('uploaded-design-image').src = response.image;
        //         document.getElementById('uploaded-design-image-preview').src = response.preview_image;
        //         document.getElementById('uploaded-design-icon-small').src = response.small_icon;
        //     })
      },
      setEditSlideImage(){
        const slideImage = document.getElementById('edit-slide-file').files[0];
           let output = document.getElementById('edit-slide');
                output.src = URL.createObjectURL(slideImage);

                output.onload = function() {
                    URL.revokeObjectURL(output.src)
                }
      },
      setEditDesignImage(){
          const designImage = document.getElementById('edit-design-image').files[0];
           let output = document.getElementById('uploaded-design-image');
                output.src = URL.createObjectURL(designImage);

                output.onload = function() {
                    URL.revokeObjectURL(output.src)
                }
      },
      setEditDesignImagePreview(){
          const designImagePreview = document.getElementById('edit-design-image-preview').files[0];
           let output = document.getElementById('uploaded-design-image-preview');
                output.src = URL.createObjectURL(designImagePreview);

                output.onload = function() {
                    URL.revokeObjectURL(output.src)
                }
      },
      setEditDesignIconSmall(){
          const designIconSmall = document.getElementById('edit-design-icon-small').files[0];
           let output = document.getElementById('uploaded-design-icon-small');
                output.src = URL.createObjectURL(designIconSmall);

                output.onload = function() {
                    URL.revokeObjectURL(output.src)
                }
      },
      cancelEditProductDesign(){
        this.editProductDesignDialog = false;
        this.$refs.editProductDesignForm.reset();
        this.$v.$reset();
        document.getElementById('edit-design-image').style.color = 'black';
        document.getElementById('edit-design-image-preview').style.color = 'black';
        document.getElementById('edit-design-icon-small').style.color = 'black';

        document.getElementById('edit-design-image').value = '';
        document.getElementById('edit-design-image-preview').value = '';
        document.getElementById('edit-design-icon-small').value = '';
      },
      submitEditProductDesign(){
        let image = document.getElementById('edit-design-image').files[0],
            imagePreview = document.getElementById('edit-design-image-preview').files[0],
            iconSmall = document.getElementById('edit-design-icon-small').files[0],
            uploadedImage = document.getElementById('uploaded-design-image').src,
            uploadedImagePreview = document.getElementById('uploaded-design-image-preview').src,
            uploadedIconSmall = document.getElementById('uploaded-design-icon-small').src,
            id = localStorage.getItem('productDesignId');

        let formData = new FormData();
            formData.append('title', this.editDesignName);
            formData.append('small_icon', iconSmall == undefined ? uploadedIconSmall : iconSmall);
            formData.append('image', image == undefined ? uploadedImage : image);
            formData.append('preview_image', imagePreview == undefined ? uploadedImagePreview : imagePreview);

            if(this.$v.editDesignName.$invalid){
                this.$v.$touch();
                image.style.color = 'red';
                imagePreview.style.color = 'red';
                iconSmall.style.color = 'red';
              return;
          } else {
            return new Promise((resolve) => {
              axios.put(`product-design/${id}`, formData)
                .then(resp => {
                  if(!resp.data.error){
                    Vue.toasted.show(i18n.tc(`successfully`),{
                      theme: 'outline',
                      singleton: true,
                      position:'top-center',
                      action :
                        {
                            text : i18n.tc(`ok`),
                            onClick : (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                  });
                  this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS')
                  this.cancelEditProductDesign();
                  } else {
                    console.log(resp.data.error)
                  }
              resolve(resp)
              })
          })

          }
      },
      deleteDesign(props){
          if (confirm(i18n.t(`areYouSureToDelete_`) + `${props.item.title}?`)) {
            this.$store.dispatch('DELETE_PRODUCT_DESIGN', props.item.id)
                .then(() => this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS'));
          }
      },
    },
    beforeCreate() {
        this.$store.dispatch('LOAD_ALL_FONTS');
        this.$store.dispatch('LOAD_ALL_BANNERS');
        this.$store.dispatch('LOAD_ALL_SLIDES');
        this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS');
    },
    mounted() {
        this.$store.dispatch('LOAD_ALL_FONTS');
        this.$store.dispatch('LOAD_ALL_BANNERS');
        this.$store.dispatch('LOAD_ALL_SLIDES');
        this.$store.dispatch('LOAD_ALL_PRODUCT_DESIGNS');
    },
}
</script>

<style lang="less">
  .tab-headline{
    color: #2EC4B6;
    font-size: 16px;
  }
  .banner-delete{
    position: relative;
    top: 90px;
    left: 75px;
    color: #fff;
    cursor: pointer;
    padding: 5px;
  }
  .banner-delete:hover{
      background: red;
      border-radius: 2px;
  }

</style>
